import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
    ECustomerMsisdnNotificationsActions,
    GetMsisdnNotifications,
    GetCustomerMsisdnNotificationsSuccess,
    GetCustomerMsisdnNotificationsFailure,
    DeleteMsisdnNotifications,
    DeleteCustomerNotifications,
    DeleteCustomerMsisdnNotificationsSuccess,
    DeleteCustomerMsisdnNotificationsFailure,
    GetCustomerNotifications
} from '../actions/customer-msisdn-notifications.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../services/notification.service';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../models/customer-msisdn-notification-paginator.interface';
import { AbstractEffects } from '../../abstract.effects';

@Injectable()
export class NotificationsEffects extends AbstractEffects {

    currentSelectedPage: number = 0;
    totalItemsPerPage: number = 0;
    id: number = 0;
    phoneNumber: string;
    notificationType: string;

    constructor(
      private actions: Actions,
      private notificationService: NotificationService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getMsisdnNotifications = createEffect(() => this.actions.pipe(
        ofType<GetMsisdnNotifications>(ECustomerMsisdnNotificationsActions.GetMsisdnNotifications),
        tap(params => {
            this.currentSelectedPage = params.currentSelectedPage;
            this.totalItemsPerPage = params.totalItemsPerPage;
            this.phoneNumber = params.phoneNumber;
        }),
        switchMap(() => this.notificationService.getMsisdnNotifications(this.phoneNumber, this.currentSelectedPage, this.totalItemsPerPage)),
        switchMap((response: CustomerMsisdnNotificationPaginatorInterface) => of(new GetCustomerMsisdnNotificationsSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetMsisdnNotifications(this.phoneNumber, this.currentSelectedPage, this.totalItemsPerPage));
            } else if (error.error['error_message'] !== 'invalid_customer_phone_number') {
                this.DisplayMessage('error_with_retry', 400, new GetCustomerMsisdnNotificationsFailure());
            } else {
                this.store.dispatch(new GetCustomerMsisdnNotificationsFailure());
            }
            return throwError(error);
        })
    ));

    deleteMsisdnNotifications = createEffect(() => this.actions.pipe(
        ofType<DeleteMsisdnNotifications>(ECustomerMsisdnNotificationsActions.DeleteMsisdnNotifications),
        tap(params => {
            this.id = params.id;
            this.phoneNumber = params.phoneNumber;
        }),
        switchMap(() => this.notificationService.deleteMsisdnNotifications(this.phoneNumber, this.id)),
        switchMap((response: any) => of(new DeleteCustomerMsisdnNotificationsSuccess())),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new DeleteMsisdnNotifications(this.phoneNumber, this.id));
            } else {
                this.DisplayMessage('error_with_retry', 400, new DeleteCustomerMsisdnNotificationsFailure());
            }
            return throwError(error);
        })
    ));

    getCustomerNotifications = createEffect(() => this.actions.pipe(
        ofType<GetCustomerNotifications>(ECustomerMsisdnNotificationsActions.GetCustomerNotifications),
        tap(params => {
            this.currentSelectedPage = params.currentSelectedPage;
            this.totalItemsPerPage = params.totalItemsPerPage;
            this.notificationType = params.notificationType;
        }),
        switchMap(() => this.notificationService.getCustomerNotifications(this.notificationType, this.currentSelectedPage, this.totalItemsPerPage)),
        switchMap((response: CustomerMsisdnNotificationPaginatorInterface) => of(new GetCustomerMsisdnNotificationsSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetCustomerNotifications(this.notificationType, this.currentSelectedPage, this.totalItemsPerPage));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetCustomerMsisdnNotificationsFailure());
            }
            return throwError(error);
        })
    ));

    deleteCustomerNotifications = createEffect(() => this.actions.pipe(
        ofType<DeleteCustomerNotifications>(ECustomerMsisdnNotificationsActions.DeleteCustomerNotifications),
        tap(params => {
            this.id = params.id;
        }),
        switchMap(() => this.notificationService.deleteCustomerNotifications(this.id)),
        switchMap((response: any) => of(new DeleteCustomerMsisdnNotificationsSuccess())),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new DeleteCustomerNotifications(this.id));
            } else {
                this.DisplayMessage('error_with_retry', 400, new DeleteCustomerMsisdnNotificationsFailure());
            }
            return throwError(error);
        })
    ));
}
